import coverPhoto from '../assets/hotspot/celebrationCover/Purim.jpg';
import lilyImage from '../assets/hotspot/headerImages/lily-s.jpg';
import celebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/Pesah_a_la_Mano_learn.jpg';
import celebrationThumbnail2 from '../assets/hotspot/celebrationPerformances/Lily_learn_concert.jpg.jpeg';

export const purim = {
  celebrationTitle: 'Purim',
  startDate: '03-02',
  endDate: '03-03',
  filterValue: 'purim',
  displayDate: 'Dates Vary Each Year',
  celebrationImage: coverPhoto,
  description: 'Purim is a Jewish holiday that celebrates the survival of the Jews in the 4th century BCE who were marked for death by their ruler. Jews all over the world celebrate Purim through a day of feasting, telling the survival story, giving gifts, and donating to charity.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105190726?fl=pl&fe=sh',
      videoImage: celebrationThumbnail1,
      songTitle: 'Pesah a la Mano',
      artistName: 'Lily',
      videoTags: [
        {
          tag: 'Purim',
        },
        {
          tag: 'Passover',
        },
      ],
      songDescription: '"Pesah a la Mano" ("Passover Is at Hand") is a Ladino song that celebrates the joyful transition from Purim to Passover. The lyrics express the love that goes into preparing for holidays, like cleaning the house and cooking traditional food to share. This song is one of many Ladino songs that connects generations through music.',
    },
    {
      videoLink: 'https://vimeo.com/1105192269?fl=pl&fe=vl',
      videoImage: celebrationThumbnail2,
      songTitle: 'Pesah a la Mano',
      artistName: 'Lily',
      videoTags: [
        {
          tag: 'Purim',
        },
        {
          tag: 'Passover',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Lily',
      artistImage: lilyImage,
    },
  ],
};
